import React, { Component } from 'react';
import { Translate } from '$common';



export default class VoiceRecord extends Component {
  static type = 'voice_record';
  static elementName = Translate.get('voice_record');
  static icon = 'microphone';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/voice-record.js